// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Common types shared across the application.
 * These mirror the Literal types used in the backend Pydantic schemas.
 */

/**
 * The roles the UI recognizes, in one place. `UserRole` is derived from this
 * array rather than declared alongside it: a hand-maintained union plus a
 * separate list is two things to edit, and they drift silently — the same shape
 * as the IAM role-name bug this replaced.
 *
 * These are the UI's canonical literals, not IAM's wire names. IAM sends display
 * names (`OrgAdmin`, `Operations-Manager`); `authService.ROLE_ALIASES` maps them.
 */
export const VALID_ROLES = ['admin', 'operations_manager', 'operator', 'executive'] as const;

export type UserRole = (typeof VALID_ROLES)[number];

export type UserStatus = 'invited' | 'pending' | 'active';
